// Photos are resized in the browser (longest side 1200 px, WebP) before upload, so they stay small
// and quick to load anywhere in the app.
const MAX_SIDE = 1200;

/** The photo as a WebP, its longest side at most 1200 px (the vendor portal's uploads too). */
export async function resizePhoto(file: Blob): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
  const canvas = new OffscreenCanvas(Math.round(bitmap.width * scale), Math.round(bitmap.height * scale));
  canvas.getContext("2d")?.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  return canvas.convertToBlob({ type: "image/webp", quality: 0.85 });
}

export async function uploadPhoto(file: Blob, name = "photo"): Promise<string> {
  const blob = await resizePhoto(file);
  const res = await fetch("/api/files", {
    method: "POST",
    headers: { "content-type": "image/webp", "x-requested-with": "hhl-ops", "x-file-name": encodeURIComponent(name) },
    body: blob,
  });
  const body = (await res.json()) as { url?: string; error?: string };
  if (!res.ok || !body.url) throw new Error(body.error ?? "Upload failed");
  return body.url;
}

/** The first image in a paste or drop, if any. */
export function imageFrom(data: DataTransfer | null): File | null {
  for (const item of data?.items ?? []) if (item.kind === "file" && item.type.startsWith("image/")) return item.getAsFile();
  return null;
}
